"use strict";

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNonce = exports.NonceContext = void 0;

var react_1 = require("react");

exports.NonceContext = (0, react_1.createContext)({
  getNonce: function getNonce() {
    return 0;
  },
  fastRefreshes: 0
});

var useNonce = function useNonce() {
  var context = (0, react_1.useContext)(exports.NonceContext);

  var _ref = (0, react_1.useState)(function () {
    return context.getNonce();
  }),
      _ref2 = _slicedToArray(_ref, 2),
      nonce = _ref2[0],
      setNonce = _ref2[1];

  (0, react_1.useEffect)(function () {
    setNonce(context.getNonce);
  }, [context]);
  return nonce;
};

exports.useNonce = useNonce;